import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import MeasureDataEntryForm from './shared/MeasureDataEntryForm';
import { message } from '../shared/Message';
import { getClientMeasureAsync, addClientMeasureDataAsync, validateRecaptcha }
  from '../../scripts/api/externalFormApi';

import UnknownClientMeasureDataDto from '../../DTOs/Measure/UnknownClientMeasureDataDto';
import RecaptchaTokenDto from '../../DTOs/shared/RecaptchaTokenDto';


const ClientMeasureDataForm = (props) => {
  const [showSuccess, setShowSuccess] = useState(false);
  const [measure, setMeasure] = useState(null);
  const { id } = useParams();

  const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

  useEffect(() => {
    getClientMeasureAsync(id).then(result => { 
      result.fields = result.fieldDefinitions.fields;
      setMeasure(result);
    }).catch(err => {
      message.error(`Error retrieving form: ${err.message}`);
    });

    const scriptUrl = 'https://www.google.com/recaptcha/api.js?render=' + siteKey;

    const script = document.createElement('script');
    script.src = scriptUrl;
    script.async = true;
    script.onload = () => {
      window.grecaptcha.ready(() => {
        console.log('reCAPTCHA is ready');
      });
    };
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, [siteKey, id]);

  const onSubmit = async (values, actions) => {
    try {
      const actionName = 'clientMeasureDataForm';
      const token = await window.grecaptcha.execute(siteKey, { action: 'clientMeasureDataForm' });
      const recaptchaResponse = await validateRecaptcha(new RecaptchaTokenDto(token, actionName));

      if (recaptchaResponse.isValid) {
        //Todo - get the first name / last name / DOB in the DTO

        const dto = new UnknownClientMeasureDataDto({ ...values });
        dto.setMeasureData(values);
        await addClientMeasureDataAsync(id, dto);
        setShowSuccess(true);
      } else {
        message.error('reCAPTCHA validation failed.');
      }
    } catch (err) {
      message.error(`Problem submitting form: ${err.message}`);
    } finally {
      actions.setSubmitting(false);
    }
  };

  //TODO - make a component for first name, last name, date of birth
  return (
    <React.Fragment>
      {showSuccess ? "Your form submission has been received. You may close this window." : 
        measure ? <MeasureDataEntryForm
          data={new UnknownClientMeasureDataDto({ ...measure })}
          isClientMeasure={true}
          onSubmit={onSubmit} /> : <></>}
    </React.Fragment>
    
  );
};

export default ClientMeasureDataForm;
